import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';

const Message = ({chat, user, canManage, onEdit, onDelete, editLabel, deleteLabel}) => {
    const managedByRole = chat.userType === 'admin' || chat.userType === 'arbitrator';
    const managedByName = chat.username === 'HKAS' || chat.username === 'Arbitrator';
    const canManageThisMessage = canManage && (managedByRole || managedByName);
    const isOwnMessage = user === chat.username;
    const loggedInType = localStorage.getItem('typeOfAccount');
    const canSeeEmailStatus = loggedInType === 'admin' || loggedInType === 'arbitrator';

    return (
    <li className={`chat ${isOwnMessage ? "right" : "left"}`}>
        {/* {user !== chat.username
             && 
             <img src={chat.img} alt={`${chat.username}'s profile pic`} />
        } */}

        {isOwnMessage ? <li style={{fontStyle:'italic', fontSize:'10px', marginBottom:'4px', float:'right', marginLeft: '5px', color:'#ffffff'}}>{chat.username}{(canSeeEmailStatus && chat.emailStatus) && <span style={{display:'inline-block',width:'8px',height:'8px',borderRadius:'50%',backgroundColor:chat.emailStatus==='sent'?'#ffd700':'#888888',marginLeft:'4px',verticalAlign:'middle'}} title={chat.emailStatus==='sent'?'Email sent':'Email pending'}/>}</li> 
                                        : <li style={{fontStyle:'italic', fontSize:'10px', marginBottom:'4px', float:'left', color:'#ffffff'}}>{chat.username}{(canSeeEmailStatus && chat.emailStatus) && <span style={{display:'inline-block',width:'8px',height:'8px',borderRadius:'50%',backgroundColor:chat.emailStatus==='sent'?'#ffd700':'#888888',marginLeft:'4px',verticalAlign:'middle'}} title={chat.emailStatus==='sent'?'Email sent':'Email pending'}/>}</li>}

        {canManageThisMessage && (
            <div
                style={{
                    position: 'absolute',
                    top: '4px',
                    right: isOwnMessage ? 'auto' : '6px',
                    left: isOwnMessage ? '6px' : 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '2px'
                }}
            >
                <Tooltip title={editLabel || 'Edit'}>
                    <IconButton
                        size="small"
                        onClick={() => onEdit(chat)}
                        style={{ color: '#ffffff', padding: '3px' }}
                    >
                        <EditIcon style={{ fontSize: '14px' }} />
                    </IconButton>
                </Tooltip>
                <Tooltip title={deleteLabel || 'Delete'}>
                    <IconButton
                        size="small"
                        onClick={() => onDelete(chat)}
                        style={{ color: '#ffffff', padding: '3px' }}
                    >
                        <CloseIcon style={{ fontSize: '14px' }} />
                    </IconButton>
                </Tooltip>
            </div>
        )}

        {/* <br></br><li style={{wordBreak: 'break-all'}}>{chat.content}</li> */}
        {/* <br></br><li style={{wordBreak: 'break-word'}}>{chat.content}</li> */}
        <br></br><li>{chat.content}</li>

        {isOwnMessage ? <li style={{fontStyle:'italic', fontSize:'10px', marginTop:'6px', float:'left', marginRight: '5px', color:'#ffffff'}}>{chat.timestamp}</li> 
                                        : <li style={{fontStyle:'italic', fontSize:'10px', marginTop:'6px', float:'right', color:'#ffffff'}}>{chat.timestamp}</li>}
    </li>
    );
};

export default Message;